import styled from 'styled-components';
import { medias, fonts, colors } from 'assets/styled/tokens';

import lupaIconSvg from 'assets/icons/magnifying.svg';
import { Button } from 'components';
import { FormGroup } from 'components/Form/subcomponents/FormGroup';
import ReactPaginate from 'react-paginate';

import { ModalGeneric } from 'components/ModalGeneric';
import { StyledModalGenericBody, StyledModalGenericClose } from 'components/ModalGeneric/styled';
import { DateRangePicker } from 'components/Form/subcomponents/DateRangePicker';
export const Paginate = styled(ReactPaginate).attrs({
  className: 'paginationBtn',
  activeClassName: 'paginationActive',
  previousLinkClassName: 'previousBtn',
  nextLinkClassName: 'nextBtn',
  pageLinkClassName: 'pageBtn',
})`
  height: 32px;
  list-style: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  @media (min-width: ${medias.desktopSm}) {
    height: 40px;
  }
  li {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    margin: 4px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    color: #888888;
    cursor: pointer;

    &:hover {
      color: #1e1e1e;
      background-color: #f5f3f1;
    }
    @media (min-width: ${medias.desktopSm}) {
      width: 32px;
      height: 32px;
    }
  }
  li:first-child {
    margin: 4px 4px 4px 0;
  }
  li:last-child {
    margin: 4px 0 4px 4px;
  }
  .paginationActive {
    color: #1e1e1e;
    background-color: #f5f3f1;
    font-weight: 700;
  }
  .previousBtn {
    display: inline-block;
    position: relative;
    z-index: 1;
    padding: 0.2em 0.8em 0.2em 0.8em;
    margin: -2em;
  }
  .nextBtn {
    display: inline-block;
    position: relative;
    z-index: 1;
    padding: 0.2em 0.8em 0.2em 0.8em;
    margin: -2em;
  }
  .pageBtn {
    display: inline-block;
    position: relative;
    z-index: 1;
    padding: 0.2em 0.8em 0.2em 0.8em;
    margin: -2em;
  }
`;
export const StyledContainerFooter = styled.div`
  width: 100%;
  display: flex;
  padding: 0px 11px 24px 11px;
  flex-direction: column;
  @media (min-width: ${medias.desktopSm}) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0px 24px 24px 24px;
  }
`;

export const LeftContainerFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
  @media (min-width: ${medias.desktopSm}) {
    justify-content: center;
    margin-bottom: 0px;
  }
  div {
    margin: 0 10px;
  }
  h3 {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.3px;
    color: #1e1e1e;
  }
  h4 {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.3px;
    color: #888888;
  }
`;
export const RightContainerFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  @media (min-width: ${medias.desktopSm}) {
    justify-content: flex-end;
  }
`;

export const Page = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: #f5f3f1;
  display: flex;
  flex-direction: column;
`;
export const Content = styled.div`
  width: 100%;
  height: 100%;
  padding: 0 15px;
  display: flex;
  margin-bottom: 0;
  flex-direction: column;
  @media (min-width: ${medias.desktopSm}) {
    justify-content: center;
    align-items: center;
    padding: 0 10%;
  }
`;
export const MobileCleanFilterDiv = styled.div`
  margin: 10px 0 24px 0;
  width: 100%;
`;
export const ContentHeader = styled.div`
  padding: 55px 0;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #888888;
  width: 100%;
  b {
    font-family: Blinker;
    font-size: 40px;
    font-weight: 700;
    line-height: 44px;
    text-align: left;
    color: #1e1e1e;
    margin-right: 105px;
  }
  @media (min-width: ${medias.desktopSm}) {
    b {
      margin-right: 5px;
    }
  }
`;
export const TablecontainerWrapper = styled.div`
  border: 1px solid #e5e5e5;
  height: auto;
  width: 100%;
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background: #ffffff;
`;
export const StyledContainerHeader = styled.div`
  background: #ffffff;
  padding: 20px 11px 0px 11px;
  display: flex;
  position: relative;
  flex-direction: row;
  border-radius: 8px 8px 0 0;
  justify-content: space-between;
  border-bottom: 1px solid #e5e5e5;
  align-items: center;
  // padding: 0 0 0 0;
  margin-bottom: 52px;
  gap: 16px;
  @media (min-width: ${medias.desktopSm}) {
    padding: 20px 24px 0px 24px;
    position: relative;
    margin-bottom: 0;
    justify-content: flex-start;
    gap: 25px;
  }
`;
export const TableTitle = styled.div`
  padding: 0px 0px 21px 0px;
  border-bottom: ${({ isActive }) => (isActive ? ' 2px solid #f38a00' : 'none')};
  font-family: Blinker;
  font-size: 16px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.5px;
  text-align: left;
  white-space: nowrap;
  color: ${({ isActive }) => (isActive ? '#f38a00' : '#9E9288')};
  cursor: pointer;
  @media (min-width: ${medias.desktopSm}) {
    font-size: 24px;
  }
`;
export const FadingWrapper = styled.div`
  position: relative;
  max-width: 100%;
`;

export const ScrollArea = styled.div`
  display: flex;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding-right: 16px;
  gap: 16px;

  &::-webkit-scrollbar {
    display: none;
  }

  & > div {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 0;
  }
`;

export const RightFade = styled.div`
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 25px;
  height: 100%;
  background: linear-gradient(to right, rgba(255, 255, 255, 0), #fff);
  pointer-events: none;
  z-index: 1;
`;

export const StyledContainerSearchBar = styled.input`
  box-sizing: border-box;
  width: 129px;
  height: 32px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  padding-left: 10px;
  ::placeholder {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.3px;
    color: #888888;
    padding: 6px 6px 6px 20px;
    background: url(${lupaIconSvg}) no-repeat left 0px center/12px;
    // background-position: left;
    //background-size: 12px;
    //background-position-x: 95%;
  }
  @media (min-width: ${medias.desktopSm}) {
    //margin-right: 20px;
    width: 336px;
    top: auto;
  }
`;
export const OpenCallButton = styled(Button)`
  position: absolute;
  top: 92px;
  right: auto;
  padding: 9px;
  width: 160px;
  height: 32px;
  justify-content: space-between;
  @media (min-width: ${medias.desktopSm}) {
    position: absolute;
    right: 24px;
    top: auto;
    width: 185px;
    height: 32px;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0.5px;
    text-align: left;
    margin-bottom: 20px;
    svg {
      margin-right: 5px;
    }
  }
`;
export const StyledInnerGridColumn = styled.div`
  display: flex;
  width: 100%;
  //align-items: center;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 0px;
  padding: 15px 11px 0px 11px;
  :nth-child(2) {
    padding: 10px 11px 0px 11px;
  }
  @media (min-width: ${medias.desktopSm}) {
    flex-direction: row;
    align-items: center;
    padding: 15px 24px 10px 24px;
    :nth-child(2) {
      gap: 24px;
      padding: 15px 24px 10px 24px;
    }
  }
`;
export const StyledInnerGridRow = styled.div`
  display: flex;
  width: 100%;
  //align-items: center;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 0px;
  padding: 15px 16px 10px 16px;
  @media (min-width: ${medias.desktopSm}) {
    flex-direction: row;
    align-items: center;
    :nth-child(2) {
      gap: 24px;
    }
  }
`;

export const StyledFormGroup = styled(FormGroup)`
  width: 100%;
  margin-bottom: 15px;
  input {
    width: 100%;
  }

  @media (min-width: ${medias.desktopSm}) {
    width: ${props => props.width};
    input {
      width: ${props => props.inputSize};
    }
    margin-bottom: 0;
  }
`;
export const StyledDateRangePicker = styled(DateRangePicker)`
  height: 32px;

  > div input {
    margin-bottom: 0 !important;
    height: 100%;
  }
  div svg {
    transform: translate(0px, -10%) !important;
  }
  @media (min-width: ${medias.desktopSm}) {
    div svg {
      transform: translate(0px, -10%) !important;
    }
  }
`;
export const RadioFormGroup = styled(FormGroup)`
  display: flex;
  flex-direction: column;
  div {
    display: flex;
    flex-direction: column;
    margin-left: 0;
    align-items: flex-start;
    justify-content: flex-start;
    label:last-of-type {
      margin-left: 0;
    }
  }
  @media (min-width: ${medias.desktopSm}) {
    align-items: flex-start;
    flex-direction: row;
    label:first-of-type {
      margin-top: 5px;
    }
    div {
      margin-left: 15px;
      justify-content: flex-start;
      label:last-of-type {
        margin-left: 0.9rem;
      }
      label:first-of-type {
        margin-top: 0px;
      }
    }
  }
`;
export const StyledFormRadio = styled.div`
  margin-bottom: 4px;
  margin-left: 15px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  font-family: ${fonts.family.text};
  font-size: 0.75rem;
  @media (min-width: ${medias.desktopSm}) {
    flex-direction: row !important;
  }

  label {
    margin-left: 0.9375rem;

    &:first-child {
      margin-left: 0;
      margin-right: 5px;
    }

    input {
      margin-right: 0.3125rem;
      cursor: pointer;
    }
  }
`;
export const SearchAndFilterContainer = styled.div`
  padding-top: 10px;
  display: flex;
  justify-content: flex-end;
  position: relative;
  width: 100%;
  @media (min-width: ${medias.desktopSm}) {
    min-width: 53%;
    gap: 10px;
  }
`;
export const ReloadButton = styled.button`
  border: 1px solid #f38a00;
  color: #f38a00;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.3px;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 10px;
  border-radius: 4px;
  height: 32px;
  min-width: 136px;
  gap: 10px;
  @media (min-width: ${medias.desktopSm}) {
    min-width: 160px;
    padding: 5px 14px;
  }
`;
export const FiltersButton = styled.button`
  position: absolute;
  top: 92px;
  right: 16%;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  color: #1e1e1e;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.5px;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 101px;
  height: 32px;
  padding: 10px 12px;
  @media (min-width: ${medias.desktopSm}) {
    position: inherit;
    top: auto;
    right: auto;
    //margin-right: 20px;
    width: 95px;
  }
`;
export const CleanFiltersButton = styled.button`
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.5px;
  text-align: left;
  color: #c25446;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;
  width: 132px;
  padding: 8px;
  //margin-right: 20px;
  @media (min-width: ${medias.desktopSm}) {
    width: 140px;
  }
`;
export const FooterContainer = styled.div`
  width: 100%;
  padding: 50px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  > p {
    margin-left: 5px;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    color: #888888;
  }
`;

export const NoOcurrenceScreen = styled.div`
  width: 100%;
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  > p {
    font-family: Blinker;
    font-size: 24px;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: 0.5px;
    text-align: center;
    color: #aaaaaa;
    margin-top: 20px;
  }
`;
// css do meu perfil

export const AtentionModal = styled(ModalGeneric)`
  h6 {
    color: ${colors.primary};
    margin-bottom: 16px;
  }
  p {
    color: ${colors.gray};
    text-align: center;
    margin-bottom: 24px;
    font-size: 16px;
    line-height: 19px;
  }

  ${StyledModalGenericClose} {
    margin-right: -8px;
  }
  ${StyledModalGenericBody} button {
    font-size: 14px;
    line-height: 16px;
    width: 96px;
  }
`;
